import React from 'react'
import '../css/section.css'
import doctor from '../img/doctorv.jpg'
import pry from '../img/priy.jpg'
import { Link } from 'react-router-dom'

import blog1 from '../img/new1.jpg'
import blog2 from '../img/new2.jpg'
import blog3 from '../img/new3.jpg'
import blog4 from '../img/new4.jpg'


const Section = () => {
    return (
        <>
            <section className="about-section">
                <div className="container">
                    <div className="row">
                        {/* Content Column */}
                        <div className="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                            <div className="inner-column">
                                <div className="sec-title">
                                    <span className="title">About  Doctor </span>
                                    <h2> Dr. Vivek pandey</h2>
                                    <h3>M.B.B.S. Medicine  General Physician  </h3>
                                </div>
                                <div className="text" style={{ marginTop: '-30px' }}>
                                    To provide best treatment patient and accept challenges throughout continuos dedicated and persevesion in the duty to be performed
                                </div>
                                <p><b>Address 1 </b>A-36, near Pandit Purwa Road, Ram Vihar Colony, Shivaji Puram, Sector 14, Indira Nagar, Lucknow, Uttar Pradesh 226016</p>
                                <br />

                                <p> <b>Address 2  </b>  BNK PHARMA 11/298 Shivajipuram Road Indira Nagar Lucknow</p>  <br />

                                <p> <b> Timing  </b> Monday : Saturday: 06 pm 09:00 pm <br />

                                    Sunday Morning : 09 am to 01:00 pm <br />

                                    Sunday Evening : 07 pm to 09:00 pm</p>

                                <br />
                                <div className="btn-box">
                                    <Link to='/Vivek'><a className="theme-btn btn-style-three">Read More </a></Link>
                                </div>
                            </div>
                        </div>

                        {/* Image Column */}
                        <div className="image-column col-lg-6 col-md-12 col-sm-12">
                            <div className="">

                                <figure className="image-1">
                                    <a href="#" className="lightbox-image" data-fancybox="images">
                                        <img
                                            title="Rahul Kumar Yadav"
                                            src={doctor} />
                                    </a>
                                </figure>
                            </div>
                        </div>

                    </div>
                </div>
            </section>



            <div className='d-flex image-container'>
                <img src={blog1} alt="blog1" className="hover-effect" />
                <img src={blog2} alt="blog2" className="hover-effect" />
                <img src={blog3} alt="blog3" className="hover-effect" />
                <img src={blog4} alt="blog4" className="hover-effect" />
            </div>





        </>
    )
}

export default Section
